import { Button } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Wrapper = styled.div`
`

export const SupplierActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 0;
`

export const ReceiveSupplierButton = styled(Button)`
    background: ${theme.colors.blue} !important;
    width: 14.5rem;
`

export const LiberateSupplierButton = styled(Button)`
    background: ${theme.colors.green2} !important;
    width: 14.5rem;
`
